

  
<div class="ms-CommandBar" >

  <div class="ms-CommandBar-sideCommands">
    <button type="button" *ngFor="let item of notificationsControlConfigs;let i=index" [title]="item.ToolTipButtonTemp" 
     class="ms-CommandButton-button"
   >
      <span class="ms-CommandButton-icon"><i class="ms-Icon ms-Icon--ShieldAlert"></i></span>
      <span class="ms-CommandButton-label">{{item?.count}}</span>
      
    </button>
    <button type="button" class="ms-CommandButton-button" (click)="onIniciarSesionClick()">
      <span class="ms-CommandButton-label" style="color: white;">{{textoLogin}}</span>
    </button>
 <!--    <button type="button" class="ms-CommandButton-button" *ngIf="IsLoged && !inSharePoint" (click)="ViewThemeCustomizationComponent()">
      <span class="ms-CommandButton-icon"><i class="ms-Icon ms-Icon--FollowUser"></i></span>
      <span class="ms-CommandButton-label">{{infoUsuario.Nombre}}</span>
    </button> -->
    <button type="button" class="ms-CommandButton-button" *ngIf="IsLoged && ViewLogOut" (click)="LimpiarLogin()">
      <span class="ms-CommandButton-icon"><i class="ms-Icon ms-Icon--SignOut"></i></span>
      <span class="ms-CommandButton-label">{{textoLogout}}</span>
    </button>
    
     </div>
      <div class="ms-CommandBar-mainArea">

      </div>
  </div>

  <!-- <app-notifications-panel (onProcessItems)="OnProcessItemshandler($event)" [config]="notificationsControlConfig" #notificationsPanel ></app-notifications-panel> -->